import React, { ForwardedRef } from "react";
import { Table as ReactTable } from "@tanstack/react-table";
import { StyledTable } from "../../table.styles";
import { ITableProps, SortingState } from "../../table.types";
import TableBody from "./tableBody";
import TableHeader from "./tableHeader";

function TableCore<T>({
    table,
    onRowClick,
    pageSize,
    rowUniqueKey,
    rowClassName,
    columnClassName,
    rowHeight,
    isLoading,
    ref,
    scrollable,
    stickyHeader,
    handleSort,
    sortingState,
    ...nativeTableProps
}: {
    table: ReactTable<T>;
    ref: ForwardedRef<HTMLTableElement>;
    pageSize: number;
    stickyHeader?: boolean;
    handleSort: (columnIndex: number) => void;
    sortingState?: SortingState;
} & Pick<
    ITableProps<T>,
    | "onRowClick"
    | "rowUniqueKey"
    | "rowClassName"
    | "columnClassName"
    | "rowHeight"
    | "isLoading"
    | "className"
    | "scrollable"
>) {
    return (
        <StyledTable
            ref={ref}
            isLoading={isLoading}
            isScrollable={scrollable}
            {...nativeTableProps}
        >
            <TableHeader<T>
                headers={table.getHeaderGroups()}
                stickyHeader={stickyHeader}
                handleSort={handleSort}
                sortingState={sortingState}
                isLoading={isLoading}
            />
            <TableBody<T>
                onRowClick={onRowClick}
                pageSize={pageSize}
                rowUniqueKey={rowUniqueKey}
                rows={table.getRowModel().rows}
                rowClassName={rowClassName}
                columnClassName={columnClassName}
                rowHeight={rowHeight}
            />
        </StyledTable>
    );
}

export default TableCore;
